import React, { useEffect, useState } from "react";
import axiosInstance from "../../api/axiosInstance";
import { Link } from "react-router-dom";
import ClusterCreatePage from "./ClusterCreatePage";

const ClusterListPage = () => {
    const [clusters, setClusters] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchClusters = async () => {
        setLoading(true);
        try {
            const res = await axiosInstance.get("/admin/clusters/");
            setClusters(res.data || []);
        } catch (err) {
            console.error("❌ Fetch clusters failed:", err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchClusters();
    }, []);

    const handleDelete = async (id) => {
        if (!window.confirm("⚠️ Confirm delete?")) return;
        try {
            await axiosInstance.delete(`/admin/clusters/${id}/`);
            setClusters((prev) => prev.filter((c) => c.id !== id));
        } catch (err) {
            console.error("❌ Delete cluster failed:", err);
        }
    };

    return (
        <div className="min-h-screen text-gray-900 dark:bg-dark-gradient">
            <div className="w-full flex flex-col gap-4 p-4">
                <div className="w-full">
                    <h1 className="text-2xl md:text-3xl font-bold tracking-tight text-green-400 drop-shadow-md">
                        🌐 Clusters
                    </h1>
                </div>
                <div className="w-full flex gap-4">
                    <section className="w-1/2">
                        <div className="overflow-x-auto rounded-2xl bg-white shadow-md ring-1 ring-black/5 dark:bg-black/30 dark:backdrop-blur-lg dark:shadow-2xl dark:border dark:border-gray-700 dark:ring-0">
                            <table className="min-w-full text-sm">
                                <thead className="text-gray-600 uppercase text-xs tracking-wider bg-gray-50 dark:bg-gray-900/60 dark:text-gray-300 dark:backdrop-blur">
                                    <tr>
                                        <th className="px-4 md:px-6 py-3 md:py-4 text-left font-semibold">
                                            ID
                                        </th>
                                        <th className="px-4 md:px-6 py-3 md:py-4 text-left font-semibold">
                                            Code
                                        </th>
                                        <th className="px-4 md:px-6 py-3 md:py-4 text-left font-semibold">
                                            Name
                                        </th>
                                        <th className="px-4 md:px-6 py-3 md:py-4 text-left font-semibold">
                                            Country
                                        </th>
                                        <th className="px-4 md:px-6 py-3 md:py-4 text-left font-semibold">
                                            Region ID
                                        </th>
                                        <th className="px-4 md:px-6 py-3 md:py-4 text-left font-semibold">
                                            URL
                                        </th>
                                        <th className="px-4 md:px-6 py-3 md:py-4 text-left font-semibold">
                                            Ennd point type
                                        </th>
                                        <th className="px-4 md:px-6 py-3 md:py-4 text-left font-semibold">
                                            Active
                                        </th>
                                        <th className="px-4 md:px-6 py-3 md:py-4 text-left font-semibold">
                                            Actions
                                        </th>
                                    </tr>
                                </thead>
                                <tbody className="divide-y divide-gray-800 text-gray-200">
                                    {loading ? (
                                        <tr>
                                            <td
                                                colSpan={8}
                                                className="text-center py-10 text-gray-500 font-medium"
                                            >
                                                ⏳ Loading clusters...
                                            </td>
                                        </tr>
                                    ) : clusters.length === 0 ? (
                                        <tr>
                                            <td
                                                colSpan={8}
                                                className="text-center py-10 text-gray-500 font-medium"
                                            >
                                                🚫 No clusters found.
                                            </td>
                                        </tr>
                                    ) : (
                                        clusters.map((c) => (
                                            <tr
                                                key={c.id}
                                                className="hover:bg-gray-900/30 transition"
                                            >
                                                <td className="px-4 md:px-6 py-3 md:py-4 text-xs">
                                                    {c.id}
                                                </td>
                                                <td className="px-4 md:px-6 py-3 md:py-4">
                                                    {c.code}
                                                </td>
                                                <td className="px-4 md:px-6 py-3 md:py-4">
                                                    {c.name}
                                                </td>
                                                <td className="px-4 md:px-6 py-3 md:py-4">
                                                    {c.country_code}
                                                </td>
                                                <td className="px-4 md:px-6 py-3 md:py-4">
                                                    {c.region_id}
                                                </td>
                                                <td className="px-4 md:px-6 py-3 md:py-4">
                                                    {c.url}
                                                </td>
                                                <td className="px-4 md:px-6 py-3 md:py-4">
                                                    {c.type}
                                                </td>
                                                <td className="px-4 md:px-6 py-3 md:py-4">
                                                    {c.is_active
                                                        ? "✅ Yes"
                                                        : "❌ No"}
                                                </td>
                                                <td className="px-4 md:px-6 py-3 md:py-4 space-x-3">
                                                    <Link
                                                        to={`/admin/clusters/edit/${c.id}`}
                                                        className="px-3 py-1 rounded bg-yellow-500 hover:bg-yellow-600 text-black font-medium"
                                                    >
                                                        Edit
                                                    </Link>
                                                    <button
                                                        onClick={() =>
                                                            handleDelete(c.id)
                                                        }
                                                        className="px-3 py-1 rounded bg-red-600 hover:bg-red-700 text-white font-medium"
                                                    >
                                                        Delete
                                                    </button>
                                                </td>
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </section>
                    <section className="w-1/2 rounded-2xl p-4 md:p-6 bg-white shadow-md ring-1 ring-black/5 dark:bg-black/30 dark:backdrop-blur-lg dark:shadow-2xl dark:border dark:border-gray-700 dark:ring-0 sticky md:top-6">
                        <ClusterCreatePage onSuccess={fetchClusters}/>
                    </section>
                </div>
            </div>
        </div>
    );
};

export default ClusterListPage;
